import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatBot from "./ChatBot";

export default function Layout({ children }) {
  // Global reveal-on-scroll observer (works on data-reveal & data-reveal-stagger)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            // Re-trigger when leaving and re-entering (works going up too)
            if (entry.boundingClientRect.top > window.innerHeight) {
              entry.target.classList.remove("is-visible");
            }
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );

    const targets = document.querySelectorAll("[data-reveal], [data-reveal-stagger]");
    targets.forEach((t) => observer.observe(t));

    // Re-scan on route changes (children change)
    const mo = new MutationObserver(() => {
      const fresh = document.querySelectorAll(
        "[data-reveal]:not(.is-visible), [data-reveal-stagger]:not(.is-visible)"
      );
      fresh.forEach((t) => observer.observe(t));
    });
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mo.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F5F3]">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ChatBot />
    </div>
  );
}
